import React from 'react';
import aboutImg1 from '../assets/Together2.jpeg';
import aboutImg2 from '../assets/churro3.jpeg';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      {/* Mission Statement — Top */}
      <div className="about__mission-banner">
        <div className="about__mission-banner-inner">
          <div className="about__mission-banner-icon">🎯</div>
          <h2 className="about__mission-banner-title">Our Mission</h2>
          <p className="about__mission-banner-text">
            Our mission is simple: to deliver sweet and savory treats that bring people together. 
            Every bite of a Churros ATX treat is a celebration of tradition, warmth, and the joy 
            of sharing a meal. From our kitchen to your hands, each bite is a celebration of 
            community. By supporting us, you're helping us spread our love for our community 
            through our food.
          </p>
        </div>
      </div>

      <div className="about__container">
        <div className="about__image-col">
          <div className="about__image-toprow">
            <div className="about__image-secondary">
              <img 
                src={aboutImg2} 
                alt="Our traditional churro machine"
              />
            </div>
            <div className="about__experience">
              <span className="about__experience-number">100%</span>
              <span className="about__experience-text">Hand-<br/>Pressed</span>
            </div>
          </div>
          <div className="about__image-wrapper">
            <img 
              src={aboutImg1} 
              alt="Hand-pressed churros at Churros ATX"
              className="about__image"
            />
            <div className="about__image-accent"></div>
          </div>
        </div>
        <div className="about__text-col">
          <span className="about__label">About Us</span>
          <h2 className="about__heading">
            Meet Cesar <span>&amp; Ivonne</span>
          </h2>
          <p className="about__text">
            Hello! We're Cesar and Ivonne. After 30 years of marriage, we've been lucky to call 
            Mexico, Canada, and Texas home.
          </p>
          <p className="about__text">
            We are Mexican, and churros have always been one of those treats that remind us of 
            home, family, and our culture.
          </p>
          <p className="about__text">
            Our churro journey started with our sister company, Pancho's Bakery (I Love Churros) 
            in Canada, and now it continues here in Georgetown, Texas with Churros ATX.
          </p>
          <p className="about__text">
            For us, food has always been the best way to meet people, make friends, and be part 
            of a community, no matter what country we're in.
          </p>
          <p className="about__text">
            When you visit our trailer, you're not just getting churros or empanadas, you're 
            supporting a small family business and a dream that has grown across three countries. 
            We're so happy to be here and can't wait to meet you.
          </p>
          <div className="about__features">
            <div className="about__feature">
              <div className="about__feature-icon">⚙️</div>
              <div>
                <h4>Tradition in Every Press</h4>
                <p>Our custom-made stainless steel churro machine from Mexico keeps the origins of our food alive</p>
              </div>
            </div>
            <div className="about__feature">
              <div className="about__feature-icon">🫶</div>
              <div>
                <h4>Small Batches, Big Heart</h4>
                <p>Never pre-frozen — every batch made from scratch, onsite</p>
              </div>
            </div>
            <div className="about__feature">
              <div className="about__feature-icon">🌾</div>
              <div>
                <h4>Local Ingredients</h4>
                <p>We source high-quality, local ingredients whenever possible</p>
              </div>
            </div>
            <div className="about__feature">
              <div className="about__feature-icon">❤️</div>
              <div>
                <h4>Our Mission</h4>
                <p>Delivering sweet &amp; savory treats that bring people together</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Extended About Sections */}
      <div className="about__extended">
        <div className="about__block">
          <div className="about__block-icon">⚙️</div>
          <h3 className="about__block-title">Tradition in Every Press</h3>
          <p className="about__block-text">
            At the center of our trailer sits our pride and joy: a custom-made, stainless steel 
            churro machine from Mexico. Built the traditional way, this machine allows us to keep 
            the origins of our food alive. We don't rely on modern automation — instead, we 
            hand-press every single churro.
          </p>
          <p className="about__block-text">
            It's a workout sometimes, but we do it to pay homage to the master bakers who created 
            our recipes. By making everything by hand, we ensure that every treat we serve stays 
            true to our heritage. The effort is a labor of love, and it's rewarded every time we 
            see that first-bite smile from our customers.
          </p>
        </div>
        <div className="about__block">
          <div className="about__block-icon">🫶</div>
          <h3 className="about__block-title">Small Batches, Big Heart</h3>
          <p className="about__block-text">
            We never use pre-frozen dough. At Churros ATX, every batch of our churros and empanadas 
            is made from scratch, onsite at our trailer and local commercial kitchen. Whether it's 
            our savory empanadas served with our famous homemade salsa or our signature vegan churros, 
            everything is prepared right in front of your eyes to ensure peak freshness and quality.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
